import { trackEvent } from 'lib/ui-analytics';
import { createUserInteraction } from '../utils';
import { TRACKING_ACTION, TRACKING_INTERACTION } from '../Constants';

export const utagPortClicked = ({ extra }) => {
	const base = {
		eventType: TRACKING_ACTION.INTERACTION,
		interaction: TRACKING_INTERACTION.PORTS.CLICK_PORT_TAB,
	};

	const interactionType = extra ? { ...base, ...extra } : base;

	const userInteractionEvent = createUserInteraction(interactionType);
	trackEvent(userInteractionEvent);
};
